// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'message.autoReply': 'Auto Reply:',
  'message.smsOptIn': 'Opted Back In',
  'message.smsOptOut': 'Opted Out Via Sms',
};
